/**
 * NovaCowgirl — "Cowgirl" persona tile. Galloping. Cross about it, then delighted about it.
 * Timing: 0.6s gallop · 8s mood swing. Geometry generated from the canonical Character
 * Bible catalog (nova.js) — regenerate rather than hand-editing paths.
 * Animations come from nova.css via the `expr-cowgirl` wrapper class
 * (applied by <NovaExpression id="cowgirl" />).
 */
import * as React from "react";

export function NovaCowgirl({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 460 460" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Nova riding a horse">
      {/* speed lines */}
      <g stroke="#1C1A17" strokeWidth="3" strokeLinecap="round">
        <line className="horse-speedline" x1="18" y1="210" x2="70" y2="210"/>
        <line className="horse-speedline" x1="8"  y1="260" x2="52" y2="260" style={{ animationDelay: "0.2s" }}/>
        <line className="horse-speedline" x1="22" y1="310" x2="66" y2="310" style={{ animationDelay: "0.45s" }}/>
      </g>
      {/* ground shadow */}
      <ellipse cx="235" cy="440" rx="140" ry="11" fill="#1C1A17" opacity="0.14"/>
      {/* dust puffs behind rear hooves */}
      <g className="horse-dust" fill="#D4A02C" opacity="0.8">
        <circle className="dust1" cx="112" cy="424" r="9" opacity="0"/>
        <circle className="dust2" cx="100" cy="432" r="6" opacity="0"/>
        <circle className="dust3" cx="120" cy="434" r="7" opacity="0"/>
      </g>
    
      <g className="horse-gallop" style={{ transformOrigin: "230px 330px" }}>
        {/* tail */}
        <path className="horse-tail" style={{ transformOrigin: "122px 310px" }} d="M 122 305 Q 78 288 66 322 Q 92 334 122 324 Z" fill="#6B4423"/>
        {/* legs (behind body) */}
        <g fill="#7A4E2A">
          <g className="horse-leg-b1" style={{ transformOrigin: "172px 345px" }}><rect x="165" y="340" width="14" height="84" rx="7"/><rect x="164" y="414" width="16" height="12" rx="4" fill="#1C1A17"/></g>
          <g className="horse-leg-f1" style={{ transformOrigin: "272px 345px" }}><rect x="265" y="340" width="14" height="84" rx="7"/><rect x="264" y="414" width="16" height="12" rx="4" fill="#1C1A17"/></g>
        </g>
        {/* body */}
        <ellipse cx="228" cy="322" rx="108" ry="52" fill="#8B5E34"/>
        {/* legs (front pair, over body) */}
        <g fill="#8B5E34">
          <g className="horse-leg-b2" style={{ transformOrigin: "198px 350px" }}><rect x="191" y="345" width="14" height="80" rx="7"/><rect x="190" y="414" width="16" height="12" rx="4" fill="#1C1A17"/></g>
          <g className="horse-leg-f2" style={{ transformOrigin: "296px 350px" }}><rect x="289" y="345" width="14" height="80" rx="7"/><rect x="288" y="414" width="16" height="12" rx="4" fill="#1C1A17"/></g>
        </g>
        {/* neck + head */}
        <path d="M 298 292 Q 332 258 348 232 L 386 262 Q 356 296 320 312 Z" fill="#8B5E34"/>
        <path d="M 306 288 Q 336 258 350 236 L 362 246 Q 340 274 318 296 Z" fill="#6B4423"/>
        <g transform="rotate(18 372 248)">
          <ellipse cx="372" cy="248" rx="36" ry="23" fill="#8B5E34"/>
          <rect x="392" y="244" width="26" height="18" rx="9" fill="#7A4E2A"/>
          <circle cx="404" cy="254" r="2.4" fill="#1C1A17"/>
        </g>
        <path d="M 352 224 l 8 -20 l 14 14 Z" fill="#6B4423"/>
        <circle cx="372" cy="240" r="4" fill="#1C1A17"/>
        {/* rider: Nova, scaled, seated on the horse's back */}
        <g transform="translate(85 42) scale(0.5)">
          
        
      <defs>
        <linearGradient id="bodyG-n1" x1="0.15" y1="0" x2="0.85" y2="1">
          <stop offset="0" stopColor="#709c9e"/>
          <stop offset="0.45" stopColor="#2D6E70"/>
          <stop offset="1" stopColor="#1e494a"/>
        </linearGradient>
        <linearGradient id="chestG-n1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#174143"/>
          <stop offset="1" stopColor="#3a6b6d"/>
        </linearGradient>
        <radialGradient id="scrG-n1" cx="0.5" cy="0.45" r="0.8">
          <stop offset="0" stopColor="#0E1626"/>
          <stop offset="0.72" stopColor="#0E1626"/>
          <stop offset="1" stopColor="#060A12"/>
        </radialGradient>
        <pattern id="pxg-n1" width="9" height="9" patternUnits="userSpaceOnUse">
          <path d="M 9 0 L 0 0 0 9" fill="none" stroke="#060A12" strokeWidth="1.6" opacity="0.65"/>
        </pattern>
        <filter id="eglow-n1" x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur stdDeviation="6"/>
        </filter>
      </defs>
        <g transform="translate(50 0)">
        
        
        <g className="nova-body" style={{ transformOrigin: "180.00px 472.00px" }} transform="rotate(0 180 347)">
          {/* Antenna stem (drawn first so head covers its base) */}
          <line x1="180" y1="122" x2="180" y2="42.60000000000001" stroke="#1C1A17" strokeWidth="2.2" strokeLinecap="round"/>
          {/* Orbital ring (behind ball, ivory) */}
          <ellipse cx="180" cy="42.60000000000001" rx="15" ry="5.3999999999999995" stroke="#F4EFE6" strokeWidth="1.6" fill="none" transform="rotate(-12 180 42.60000000000001)"/>
          {/* Antenna ball */}
          <circle className="antenna-ball" cx="180" cy="42.60000000000001" r="7" fill="#D4541F"/>
          <ellipse cx="177.9" cy="40.150000000000006" rx="2.94" ry="2.1" fill="#FFFFFF" opacity="0.55"/>
          {/* Front half of orbital ring (over ball) so it appears to encircle */}
          <path d="M 165.3 43.10000000000001 A 15 5.3999999999999995 -12 0 0 194.7 40.400000000000006"
                stroke="#F4EFE6" strokeWidth="1.6" fill="none" opacity="0.95"/>
          
    
          {/* HEAD outer (glossy) */}
          <rect x="60" y="110" width="240" height="170" rx="36" fill="url(#bodyG-n1)"/>
          {/* Bezel inset (darker ring) */}
          <rect x="82" y="132" width="196" height="126" rx="28" fill="#1F5759"/>
          {/* Face screen: recessed navy display */}
          <rect x="88" y="138" width="184" height="114" rx="22" fill="url(#scrG-n1)"/>
    
          {/* Cheeks (on teal head, flanking screen) */}
          
        <ellipse className="cheek cheek-l" cx="82" cy="230" rx="14" ry="9" fill="#E89478" opacity="0.6"/>
        <ellipse className="cheek cheek-r" cx="278" cy="230" rx="14" ry="9" fill="#E89478" opacity="0.6"/>
      
    
          {/* Eyes: glow pass + sharp pass */}
          <g filter="url(#eglow-n1)" opacity="0.75">
          <g className="eye-left" style={{ transformOrigin: "146.88px 195.00px" }}><path d="M 153.57 174.73 Q 158.14 170.85 158.10 176.85 L 157.82 223.49 Q 157.78 229.49 152.34 226.95 L 118.89 211.35 Q 113.46 208.82 118.03 204.93 Z" fill="#A8C8E8" opacity="1"/></g>
          <g className="eye-right" style={{ transformOrigin: "213.12px 195.00px" }}><path d="M 201.90 176.85 Q 201.86 170.85 206.43 174.73 L 241.97 204.93 Q 246.54 208.82 241.11 211.35 L 207.66 226.95 Q 202.22 229.49 202.18 223.49 Z" fill="#A8C8E8" opacity="1"/></g>
        </g>
          
          <g className="eye-left" style={{ transformOrigin: "146.88px 195.00px" }}><path d="M 153.57 174.73 Q 158.14 170.85 158.10 176.85 L 157.82 223.49 Q 157.78 229.49 152.34 226.95 L 118.89 211.35 Q 113.46 208.82 118.03 204.93 Z" fill="#A8C8E8" opacity="1"/></g>
          <g className="eye-right" style={{ transformOrigin: "213.12px 195.00px" }}><path d="M 201.90 176.85 Q 201.86 170.85 206.43 174.73 L 241.97 204.93 Q 246.54 208.82 241.11 211.35 L 207.66 226.95 Q 202.22 229.49 202.18 223.49 Z" fill="#A8C8E8" opacity="1"/></g>
        
    
          {/* Single quiet tear (Sad) — on face screen, below right eye */}
          
    
          {/* Pixel grid over the display (LED look) */}
          <rect x="88" y="138" width="184" height="114" rx="22" fill="url(#pxg-n1)"/>
          {/* Screen glare */}
          <ellipse cx="146.88" cy="148" rx="55.199999999999996" ry="9" fill="#8FB4E8" opacity="0.13"/>
          {/* Head specular */}
          <ellipse cx="112" cy="126" rx="36" ry="9" fill="#FFFFFF" opacity="0.35" transform="rotate(-10 112 126)"/>
    
          {/* BODY outer (glossy) */}
          <rect x="50" y="302" width="260" height="170" rx="36" fill="url(#bodyG-n1)"/>
          {/* Chest storage: interior + items behind a hinged door */}
          <rect x="72" y="324" width="216" height="126" rx="26" fill="#0B1220"/>
          <g className="chest-items" style={{ opacity: "0" }}>
            <path d="M 141.12 358 l 6.2 12.7 13.9 2 -10 9.8 2.4 13.9 -12.5 -6.6 -12.5 6.6 2.4 -13.9 -10 -9.8 13.9 -2 Z" fill="#D4A02C"/>
            <g transform="translate(190.8 368)">
              <rect x="0" y="0" width="44" height="30" rx="5" fill="#1C1A17"/>
              <circle cx="22" cy="15" r="9" fill="#3A3733" stroke="#F4EFE6" strokeWidth="1.4"/>
              <rect x="31" y="3" width="8" height="5" rx="1.5" fill="#3A3733"/>
            </g>
          </g>
          {/* Chest door (hinged at left edge) */}
          <g className="chest-door" style={{ transformOrigin: "74px 387.0px" }}>
            <rect x="72" y="324" width="216" height="126" rx="26" fill="url(#chestG-n1)"/>
            <line x1="79" y1="336" x2="79" y2="438" stroke="#0B1220" strokeWidth="2.4" opacity="0.55"/>
            <circle cx="272" cy="387.0" r="5" fill="#6d9293"/>
          </g>
          {/* Body specular */}
          <ellipse cx="98" cy="316" rx="30" ry="7" fill="#FFFFFF" opacity="0.25" transform="rotate(-8 98 316)"/>
    
          {/* Arms (drawn over body) */}
          
        </g>
        </g>
      
          <g transform="translate(50 0)">
            {/* happy overlay eyes (visible in second half of mood swing) */}
            <g className="rider-happy-eyes" style={{ opacity: "0" }}>
              <rect x="115" y="160" width="130" height="70" rx="16" fill="#0E1626"/>
              <path d="M 122 199 Q 147 165 172 199" stroke="#A8C8E8" strokeWidth="11" strokeLinecap="round" fill="none"/>
              <path d="M 188 199 Q 213 165 238 199" stroke="#A8C8E8" strokeWidth="11" strokeLinecap="round" fill="none"/>
            </g>
            {/* cowboy hat */}
            <ellipse cx="180" cy="110" rx="92" ry="16" fill="#B8862B" stroke="#1C1A17" strokeWidth="3"/>
            <path d="M 130 110 Q 126 54 158 50 Q 180 60 202 50 Q 234 54 230 110 Z" fill="#B8862B" stroke="#1C1A17" strokeWidth="3" strokeLinejoin="round"/>
            <rect x="130" y="94" width="100" height="13" fill="#1C1A17"/>
          </g>
        </g>
      </g>
    </svg>
  );
}
